import React from "react";
import { GET, PUT } from "Common/api";
import Dialog from "Components/Fragment/Dialog";
import LuvitComponent from "LuvitComponent";
import config from "lib/config";
import { Wysiwyg, TOOLBAR_TYPES } from "Components/Module/Wysiwyg";
import { Button } from "Components/Base/Inputs/Button";
import { IconButton } from "lib/components/Button";
import { Grid } from "Components/Base/Layout/Grid";
import theme from "lib/themes/theme";
import { ThemeProvider } from "@mui/material/styles";
import { Checkbox } from "Components/Base/Inputs/Checkbox";
import { sanitize } from "lib/sanitizer";

const API = "v1/help/:sectionId";
const LANGUAGEID = config.languageId;
const HELP_KEY = "H";

export default class Help extends LuvitComponent {
  constructor(props, context) {
    super(props, context, "Help");

    this.SaveSystemHelpTextHeader = this.SaveSystemHelpTextHeader.bind(this);
    this.SaveCustomHelpTextHeader = this.SaveCustomHelpTextHeader.bind(this);
    this.updateSectionId = this.updateSectionId.bind(this);
    this.openHelp = this.openHelp.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
  }

  async componentWillMount() {
    const isSysAdmin = await GET("v1/users/issysadmin");
    const isLuvitAdmin = await GET("v1/users/isluvitadmin");
    const urlParams = new URLSearchParams(window.location.search);
    const isOpen = urlParams.get("open") === "true";
    const inWindow = urlParams.get("window") === "true";

    this.setState({
      isLUVITAdmin: isLuvitAdmin,
      isSysAdmin: isSysAdmin,
      pageHelp: this.props.pageHelp,
      inIframe: this.props.inIframe,
      inWindow: inWindow,
      helpIsAutoOpen: false,
      open: isOpen,
    });

    window.addEventListener("iframeNavigation", this.updateSectionId, false);
    this.onRefresh();
  }

  componentDidMount() {
    $(window).on("keydown", this.onKeyDown);
  }

  componentWillUnmount() {
    window.removeEventListener("iframeNavigation", this.updateSectionId);
    $(window).off("keydown", this.onKeyDown);
  }

  onKeyDown(e) {
    if (!(e.shiftKey && e.ctrlKey)) return;

    if (e.key.toUpperCase() == HELP_KEY && e.shiftKey && e.ctrlKey) {
      this.setState({ open: true });
    }
  }

  updateSectionId(e) {
    if (!e.detail) {
      this.setState({ ready: false });
      return;
    }
    let sectionId = e.detail.toLowerCase().replace(/^https?:\/\/.*?\//i, "/");
    let urlRoot = config.urlRoot.toLowerCase();
    let i = sectionId.indexOf(urlRoot);
    if (i >= 0) sectionId = sectionId.substr(i + urlRoot.length);

    sectionId = sectionId.replace(/\//g, "").replace(".aspx", "");

    i = sectionId.indexOf("?");
    if (i >= 0) sectionId = sectionId.substring(0, i);

    this.setState({ sectionId });
  }

  async onRefresh(forceUpdate) {
    let sectionId = this.props.sectionId || this.state.sectionId;
    let modal = true;
    const helpIsAutoOpen = JSON.parse(localStorage.getItem("helpIsAutoOpen"));

    if (helpIsAutoOpen && helpIsAutoOpen !== this.state.helpIsAutoOpen) {
      this.setState({ helpIsAutoOpen });
    }

    if (!sectionId) {
      sectionId = luvit.GetQueryString("sectionid");
      modal = false;
    }

    if (!sectionId || (!forceUpdate && this.sectionId == sectionId)) return;

    this.sectionId = sectionId;

    let help = await GET(`${API}?languageId=:languageId`, {
      sectionId: sectionId,
      languageId: LANGUAGEID,
    });

    if (!help.helpTextSystem) {
      help.helpTextSystem = `<p>[${this.l("enterSystemHelpContent")}]</p>`;
    }

    if (!help.helpTextCustom) {
      help.helpTextCustom = `<p>[${this.l("enterCustomerHelpContent")}]</p>`;
    }
    this.setState({
      ready: true,
      help,
      sectionId,
      editHelpTextSystem: false,
      editHelpTextCustom: false,
      editSystemHelpTextHeader: false,
      editCustomHelpTextHeader: false,
      modal,
    });
    localStorage.setItem("helpIsAutoOpen", false);
  }

  componentDidUpdate() {
    this.onRefresh();
  }

  hasRights(system) {
    return system ? this.state.isSysAdmin : this.state.isLUVITAdmin;
  }

  LoadEditor(system) {
    return (() => {
      if (!this.hasRights(!system)) return; // sysadmins does not have rights to edit system-texts...

      let newState = {};
      newState[system ? "editHelpTextSystem" : "editHelpTextCustom"] = true;

      this.setState(newState);

      setTimeout(function () {
        $(".modal").scrollTop(80);
      }, 300);
    }).bind(this);
  }

  CancelEditSystemHelpText() {
    this.setState({ editHelpTextSystem: false });
  }

  CancelEditCustomHelpText() {
    this.setState({ editHelpTextCustom: false });
  }

  SaveHelpText(system) {
    return (async () => {
      const html = system
        ? this.state.help.helpTextSystem
        : this.state.help.helpTextCustom;

      await PUT(
        "v1/help/:sectionId/:type",
        {
          sectionId: this.state.sectionId,
          type: system ? "system" : "custom",
        },
        { languageId: LANGUAGEID, helpText: sanitize(html) },
      );
      this.onRefresh(true);
    }).bind(this);
  }

  EditSystemHelpTextHeader() {
    if (!this.hasRights(false)) return;

    this.setState({ editSystemHelpTextHeader: true });
    document.getElementById("TxtSystemHelpTextHeader").focus();
  }

  EditCustomHelpTextHeader() {
    if (!this.hasRights(true)) return;

    this.setState({ editCustomHelpTextHeader: true });
    document.getElementById("TxtCustomHelpTextHeader").focus();
  }

  HandleEnterForHeader(saveCb) {
    return ((event) => {
      if (event.charCode != 13) return;

      saveCb.call(this);
      event.preventDefault();
    }).bind(this);
  }

  async SaveSystemHelpTextHeader() {
    if (this.refs.TxtSystemHelpTextHeader.value != "") {
      await PUT(
        `v1/help/:sectionId/system/header?languageId=:languageId&helpText=:helpText`,
        {
          sectionId: this.state.sectionId,
          languageId: LANGUAGEID,
          helpText: this.refs.TxtSystemHelpTextHeader.value,
        },
      );
      this.onRefresh(true);
    }
  }

  async SaveCustomHelpTextHeader() {
    if (this.refs.TxtCustomHelpTextHeader.value != "") {
      await PUT(
        `v1/help/:sectionId/custom/header?languageId=:languageId&helpText=:helpText`,
        {
          sectionId: this.state.sectionId,
          languageId: LANGUAGEID,
          helpText: this.refs.TxtCustomHelpTextHeader.value,
        },
      );
      this.onRefresh(true);
    }
  }

  CancelEditSystemHelpTextHeader() {
    this.setState({ editSystemHelpTextHeader: false });
  }

  CancelEditCustomHelpTextHeader() {
    this.setState({ editCustomHelpTextHeader: false });
  }

  ToggleHelp(helptype) {
    return (async () => {
      let secId = !this.props.sectionId
        ? this.state.sectionId
        : this.props.sectionId;
      if (helptype == "system") {
        await PUT(
          `v1/help/:sectionId/:type/show?languageId=:languageId&show=:show`,
          {
            sectionId: secId,
            type: "system",
            languageId: LANGUAGEID,
            show: !this.state.help["helpTextSystemShow"],
          },
        );
      }
      if (helptype == "customsystem") {
        await PUT(
          "v1/help/:sectionId/:type/show?languageId=:languageId&show=:show",
          {
            sectionId: secId,
            type: "customsystem",
            languageId: LANGUAGEID,
            show: !this.state.help["helpTextCustomSystemShow"]
              ? "true"
              : "false",
          },
        );
      }
      if (helptype == "custom") {
        await PUT(
          "v1/help/:sectionId/:type/show?languageId=:languageId&show=:show",
          {
            sectionId: secId,
            type: "custom",
            languageId: LANGUAGEID,
            show: !this.state.help["helpTextCustomShow"] ? "true" : "false",
          },
        );
      }
      this.onRefresh(true);
    }).bind(this);
  }

  toggleDontShowAgain(e) {
    localStorage.setItem("dontShowAgain", e.target.checked);
  }

  async ToggleCustomHelp() {
    let secId = !this.props.sectionId
      ? this.state.sectionId
      : this.props.sectionId;
    await PUT(
      `v1/help/:sectionId/custom/show?languageId=:languageId&show=:show`,
      {
        sectionId: secId,
        languageId: LANGUAGEID,
        show: !this.state.help.helpTextCustomShow ? "true" : "false",
      },
    );
    this.onRefresh(true);
  }

  OpenHelpInNewWindow() {
    this.setState({ open: false });

    window.open(
      `${luvit.appPath}/help/help.aspx?sectionid=${this.state.sectionId}&open=true&window=true`,
      "LuvitHelp",
      "width=800px,height=600px,resizable=yes,statusbar=yes",
    );
  }

  renderModal() {
    return (
      <Dialog
        title={this.l("help")}
        text={this.renderHelpContent()}
        onClose={this.onCloseHelp.bind(this)}
        open={this.state.open}
        maxWidth="md"
        fullWidth
        cancelText={this.l("close")}
        disableEnforceFocus={
          this.state.editHelpTextCustom || this.state.editHelpTextSystem
        }
      />
    );
  }

  renderHelpContent() {
    const { inWindow } = this.state;
    const systemHelpText = this.state.help.helpTextSystem;
    const customHelpText = this.state.help.helpTextCustom;

    const systemHtml = { __html: systemHelpText };
    const customHtml = { __html: customHelpText };

    //No help available and not an admin
    if (
      !this.hasRights(false) &&
      !this.hasRights(true) &&
      !this.state.help.helpTextSystemShow &&
      !this.state.help.helpTextCustomShow &&
      !this.state.help.helpTextCustomSystemShow
    ) {
      return (
        <div className="help-notavailable">{this.l("nohelpavailable")}</div>
      );
    }

    return (
      <div className="help-content">
        {!inWindow && (
          <button
            autoFocus
            className={`button-transparent ${
              this.state.modal ? "help-openinnewwindow" : "hidden"
            }`}
            onClick={this.OpenHelpInNewWindow.bind(this)}
          >
            {this.l("openinnewwindow")}{" "}
            <span className="icon-link" aria-hidden="true"></span>
          </button>
        )}
        <fieldset
          id="SystemHelp"
          className={
            this.hasRights(false)
              ? ""
              : this.state.help.helpTextSystemShow
                ? ""
                : "hidden"
          }
        >
          <h3
            onClick={this.EditSystemHelpTextHeader.bind(this)}
            className={
              this.state.editSystemHelpTextHeader
                ? "hidden"
                : this.hasRights(true)
                  ? "help-edit"
                  : ""
            }
          >
            {this.state.help.helpTextHeaderSystem
              ? this.state.help.helpTextHeaderSystem
              : this.l("enterSystemHelpTitle")}
          </h3>
          <div
            className={
              this.state.editSystemHelpTextHeader
                ? "help-edit-header"
                : "hidden"
            }
          >
            <Grid container spacing={1} alignItems="center">
              <Grid item>
                <input
                  type="text"
                  id="TxtSystemHelpTextHeader"
                  ref="TxtSystemHelpTextHeader"
                  defaultValue={this.state.help.helpTextHeaderSystem}
                  onKeyPress={this.HandleEnterForHeader(
                    this.SaveSystemHelpTextHeader,
                  )}
                />
              </Grid>
              <Grid item>
                <Button
                  onClick={this.SaveSystemHelpTextHeader}
                  label={this.l("save")}
                />
              </Grid>
              <Grid item>
                <Button
                  color="secondary"
                  variant="outlined"
                  onClick={this.CancelEditSystemHelpTextHeader.bind(this)}
                  label={this.l("cancel")}
                />
              </Grid>
            </Grid>
          </div>
          <div
            dangerouslySetInnerHTML={systemHtml}
            className={this.state.editHelpTextSystem ? "hidden" : ""}
            onClick={this.LoadEditor(true)}
          ></div>

          {this.state.editHelpTextSystem && (
            <div style={{ maxWidth: "inherit" }}>
              <Wysiwyg
                value={systemHelpText}
                onChange={(value) =>
                  this.setState({
                    help: { ...this.state.help, helpTextSystem: value },
                  })
                }
                toolbar={TOOLBAR_TYPES.FULL}
              />
              <br />
              <Grid
                container
                spacing={1}
                alignItems="center"
                justifyContent="end"
              >
                <Grid item>
                  <Button
                    onClick={this.SaveHelpText(true)}
                    label={this.l("save")}
                  />
                </Grid>
                <Grid item>
                  <Button
                    color="secondary"
                    variant="outlined"
                    onClick={this.CancelEditSystemHelpText.bind(this)}
                    label={this.l("cancel")}
                  />
                </Grid>
              </Grid>
            </div>
          )}

          {this.hasRights(false) && (
            <Checkbox
              checked={this.state.help.helpTextSystemShow}
              onChange={this.ToggleHelp("system")}
              label={this.l("publish")}
            />
          )}
          {this.hasRights(true) && (
            <Checkbox
              checked={this.state.help.helpTextCustomSystemShow}
              onChange={this.ToggleHelp("customsystem")}
              label={this.l("availableforusers")}
            />
          )}
        </fieldset>
        <br />
        <fieldset
          id="CustomHelp"
          className={
            this.hasRights(true)
              ? ""
              : this.state.help.helpTextCustomShow
                ? ""
                : "hidden"
          }
        >
          <h3
            onClick={this.EditCustomHelpTextHeader.bind(this)}
            className={
              this.state.editCustomHelpTextHeader
                ? "hidden"
                : this.hasRights(true)
                  ? "help-edit"
                  : ""
            }
          >
            {this.state.help.helpTextHeaderCustom
              ? this.state.help.helpTextHeaderCustom
              : this.l("enterCustomerHelpTitle")}
          </h3>
          <div
            className={
              this.state.editCustomHelpTextHeader
                ? "help-edit-header"
                : "hidden"
            }
          >
            <Grid container spacing={1} alignItems="center">
              <Grid item>
                <input
                  type="text"
                  id="TxtCustomHelpTextHeader"
                  ref="TxtCustomHelpTextHeader"
                  defaultValue={this.state.help.helpTextHeaderCustom}
                  onKeyPress={this.HandleEnterForHeader(
                    this.SaveCustomHelpTextHeader,
                  )}
                />
              </Grid>
              <Grid item>
                <Button
                  onClick={this.SaveCustomHelpTextHeader}
                  label={this.l("save")}
                />
              </Grid>
              <Grid item>
                <Button
                  color="secondary"
                  variant="outlined"
                  onClick={this.CancelEditCustomHelpTextHeader.bind(this)}
                  label={this.l("cancel")}
                />
              </Grid>
            </Grid>
          </div>
          <div
            dangerouslySetInnerHTML={customHtml}
            className={this.state.editHelpTextCustom ? "hidden" : ""}
            onClick={this.LoadEditor(false)}
          ></div>

          {this.state.editHelpTextCustom && (
            <div style={{ maxWidth: "inherit" }}>
              <Wysiwyg
                value={customHelpText}
                onChange={(value) =>
                  this.setState({
                    help: { ...this.state.help, helpTextCustom: value },
                  })
                }
                toolbar={TOOLBAR_TYPES.FULL}
              />
              <br />
              <Grid container spacing={1} alignItems="center">
                <Grid item>
                  <Button
                    onClick={this.SaveHelpText(false)}
                    label={this.l("save")}
                  />
                </Grid>
                <Grid item>
                  <Button
                    color="secondary"
                    variant="outlined"
                    onClick={this.CancelEditCustomHelpText.bind(this)}
                    label={this.l("cancel")}
                  />
                </Grid>
              </Grid>
            </div>
          )}
          {this.hasRights(true) && (
            <Checkbox
              checked={this.state.help.helpTextCustomShow}
              onChange={this.ToggleHelp("custom")}
              label={this.l("availableforusers")}
            />
          )}
        </fieldset>
        {this.state.helpIsAutoOpen && (
          <Checkbox
            checked={this.state.help.helpTextCustomShow}
            onChange={(e) => this.toggleDontShowAgain(e)}
            label={this.l("dontShowAgain")}
          />
        )}
      </div>
    );
  }

  renderContent() {
    const { modal, inWindow } = this.state;
    let content = this.renderModal();

    if (!modal || inWindow) {
      content = this.renderHelpContent();
    }

    return content;
  }

  onCloseHelp() {
    this.setState({
      open: false,
      editHelpTextSystem: false,
      editHelpTextCustom: false,
      editHelpTextSystemHeader: false,
      editHelpTextCustomHeader: false,
      helpIsAutoOpen: false,
    });
    localStorage.setItem("helpIsAutoOpen", false);
  }

  openHelp(e) {
    e.preventDefault();
    this.setState({ open: true });
  }

  doRender() {
    let helpClass = "help";
    const { inWindow, modal, open, pageHelp, inIframe } = this.state;
    const { addClass } = this.props || "";

    if (pageHelp) helpClass += " help-page";

    if (inIframe) helpClass += " help-iframe";
    if (
      !this.state ||
      !this.state.ready ||
      (!this.hasRights(false) &&
        !this.hasRights(true) &&
        !this.state.help.helpTextSystemShow &&
        !this.state.help.helpTextCustomShow)
    ) {
      return <div />;
    }
    const style = this.props.forWidget ? {} : {};
    const helpIconID = `Help-${inIframe ? "frame-" : ""}content-${Math.floor(
      Math.random() * Math.floor(1000),
    )}`;

    return (
      <ThemeProvider theme={theme}>
        <div
          className={`${!inWindow ? addClass : ""} ${helpClass}`}
          id={helpIconID}
        >
          {!inWindow && (
            <IconButton
              label={this.l("help")}
              icon="icon-help"
              style={style}
              className={`button-transparent ${this.props.addClass || ""} ${
                modal ? "" : "hidden"
              }`}
              onClick={this.openHelp}
              aria-label={this.l("help")}
              title={this.l("help")}
            />
          )}
          {(open || !modal) && this.renderContent()}
        </div>
      </ThemeProvider>
    );
  }
}
